import {
  ROUTE_PATH_LIST_RENTAL_PORTAL,
  ROUTE_UI_SECTION_NAME_RENTAL_PORTAL,
} from '../../constants/route'

import ContractIcon from '../../icons/contract.svg'
import ArchiveIcon from '../../icons/delete.svg'
import RentalPortalIcon from '../../icons/rental-portal.svg'
import SettingsIcon from '../../icons/settings.svg'
import StatisticIcon from '../../icons/statistic.svg'
import UsersIcon from '../../icons/users-1.svg'
import ViewingIcon from '../../icons/viewing.svg'

export const QA_NAME_RENTAL_PORTAL_PAGE = 'rentalPortal'

export const QA_NAME_RENTAL_PORTAL_SUB_MENU = 'rentalPortal'

export const QA_NAME_RENTAL_PORTAL_SUB_MENU_SETTINGS = 'rentalPortalSettings'

export const RENTAL_PORTAL_SUBSECTION_LIST = [
  {
    EmptyStateIcon: StatisticIcon,
    emptyTextKey: 'RentalPortal.OverviewNoDataKey',
    name: ROUTE_PATH_LIST_RENTAL_PORTAL.overview,
    title: 'RentalPortal.OverviewTitleKey',
    uiSectionName: ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.overview,
  },
  {
    EmptyStateIcon: RentalPortalIcon,
    emptyTextKey: 'RentalPortal.ListingsNoDataKey',
    name: ROUTE_PATH_LIST_RENTAL_PORTAL.listings,
    title: 'RentalPortal.ListingsTitleKey',
    uiSectionName: ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.listings,
  },
  {
    EmptyStateIcon: UsersIcon,
    emptyTextKey: 'RentalPortal.ApplicantsNoDataKey',
    name: ROUTE_PATH_LIST_RENTAL_PORTAL.applicants,
    title: 'RentalPortal.ApplicantsTitleKey',
    uiSectionName: ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.applicants,
  },
  {
    EmptyStateIcon: ViewingIcon,
    emptyTextKey: 'RentalPortal.ViewingsNoDataKey',
    name: ROUTE_PATH_LIST_RENTAL_PORTAL.viewings,
    title: 'RentalPortal.ViewingsTitleKey',
    uiSectionName: ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.viewings,
  },
  {
    EmptyStateIcon: ContractIcon,
    emptyTextKey: 'RentalPortal.ContractsNoDataKey',
    name: ROUTE_PATH_LIST_RENTAL_PORTAL.contracts,
    title: 'RentalPortal.ContractsTitleKey',
    uiSectionName: ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.contracts,
  },
  {
    EmptyStateIcon: ArchiveIcon,
    emptyTextKey: 'RentalPortal.ArchiveNoDataKey',
    name: ROUTE_PATH_LIST_RENTAL_PORTAL.archive,
    title: 'RentalPortal.ArchiveTitleKey',
    uiSectionName: ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.archive,
  },
  {
    EmptyStateIcon: SettingsIcon,
    emptyTextKey: 'RentalPortal.MatchSettingsEmptyKey',
    isInSettingsAccordion: true,
    name: ROUTE_PATH_LIST_RENTAL_PORTAL.settings,
    title: 'RentalPortal.MatchSettingsPageTitleKey',
    uiSectionName: ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.settingsMatching,
  },
  {
    EmptyStateIcon: SettingsIcon,
    emptyTextKey: 'RentalPortal.IntegrationsEmptyKey',
    isInSettingsAccordion: true,
    name: ROUTE_PATH_LIST_RENTAL_PORTAL.settingsIntegrations,
    title: 'RentalPortal.IntegrationsTitleKey',
    uiSectionName: ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.root,
  },
  {
    EmptyStateIcon: SettingsIcon,
    emptyTextKey: 'RentalPortal.RulesPolicyEmptyKey',
    isInSettingsAccordion: true,
    name: ROUTE_PATH_LIST_RENTAL_PORTAL.settingsRulesPolicy,
    title: 'RentalPortal.RulesPolicyTitleKey',
    uiSectionName: ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.root,
  },
  {
    EmptyStateIcon: SettingsIcon,
    emptyTextKey: 'RentalPortal.RightsRolesEmptyKey',
    isInSettingsAccordion: true,
    name: ROUTE_PATH_LIST_RENTAL_PORTAL.settingsRightsRoles,
    title: 'RentalPortal.RightsRolesTitleKey',
    uiSectionName: ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.root,
  },
]

export const PORTAL_AVATAR_TEXT = {
  ImmoScout24: 'Immo Scout',
  Immowelt: 'Immo Welt',
}

export const LISTING_PROFILE_TAB_APPLICANTS = 'applicants'

export const RENTAL_PORTAL_CSV_MIME = 'text/csv;charset=utf-8'

export const RENTAL_PORTAL_CSV_BOM = '\uFEFF'

export const RENTAL_PORTAL_CSV_SEPARATOR = ';'

export const RENTAL_PORTAL_CSV_LINE_BREAK = '\r\n'

export const RENTAL_PORTAL_PROFILE_TAB_COUNT_LIMIT = 99

export const RENTAL_PORTAL_PAGE_READ_KEY_SEPARATOR = '|'

export const RENTAL_PORTAL_PAGE_READ_EMPTY_COUNT = 0

export const RENTAL_PORTAL_TOO_FEW_APPROVERS_REASON = 'too_few_approvers'
